module.exports = "//static.hsappstatic.net/ecosystem-marketplace-core/static-1.6629/img/storefront-header-blobs.svg"